import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { Button } from '@material-ui/core';
import { Breadcrumb } from 'components';
import CustomersList from './CustomersList';


const Customers = () => {
  const history = useHistory();
  const { customerGroups } = useSelector((state: IReduxState) => state.customers);
  return (
    <div className="flex-grow flex-column relative h-full scroll-y pb-5">
      <div className="mb-sm-30">
        <Breadcrumb
          routeSegments={[
            { name: 'Customers'}
          ]}
        />
      </div>
      <div>
        <div className="flex items-center justify-end w-full px-10 mb-5">
          <Button
            color="primary"
            variant="contained"
            onClick={() => history.push({
              pathname: '/customers/create',
              state: {
                customer: {},
                customerGroups
              }
            })}
          >
            Create Customer
          </Button>
        </div>
        <CustomersList />
      </div>
    </div>
  );
};

export default Customers;
